// extracted by mini-css-extract-plugin
export default {"dealerManagementContainer":"_dealer-management_dealerManagementContainer__-IN2u"};